import Vue from 'vue';
import Login from './components/Login';
import { enableBugsnagTracking } from '../helpers/bugsnag'

enableBugsnagTracking(Vue);
let app = new Vue({
    el: "#app",
    components: { Login }
});
